import { Box } from 'src/design/atoms/Box';
import { Center } from 'src/design/atoms/Center';
import { Container } from 'src/design/atoms/Container';
import { Loader } from 'src/design/atoms/Loader';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import React from 'react';
import { useMsal } from '@azure/msal-react';
import logo from 'src/assets/firetrol.png';
import { logger } from 'src/utils';
import { loginRequest } from 'src/auth/authConfig';
import AuthFooter from './AuthFooter';
import AuthBackground from './BackgroundImage';
import MainCard from './MainCard';

interface LoginProps {
  initialLocation?: string | null;
}
export const Login: React.FC<LoginProps> = ({ initialLocation }) => {
  const { instance, inProgress } = useMsal();

  React.useEffect(() => {
    login();
  }, []);

  const login = async () => {
    try {
      await instance.handleRedirectPromise();

      logger.debug('MSAL - inProgress', { inProgress });

      if (
        instance.getActiveAccount() ||
        instance.getAllAccounts().length > 0 ||
        inProgress !== 'none'
      ) {
        return;
      }

      const url = await localStorage.getItem('@Firetrol:redirect');
      await instance.loginRedirect({
        ...loginRequest,
        redirectStartPage: `${window.location.origin}${url || '/'}`,
      });
    } catch (error) {
      logger.error('Login error', { err: error });
    }
  };

  return (
    <Box
      style={{ minHeight: '100vh', position: 'relative', overflow: 'hidden' }}
    >
      <AuthBackground />
      <Stack
        justify="flex-end"
        style={{ minHeight: '100vh', position: 'relative', zIndex: 1 }}
      >
        <Box ml="md" mt="md">
          <img src={logo} alt="logo" height={30} />
        </Box>
        <Center style={{ minHeight: 'calc(100vh - 134px)', flex: 1 }}>
          <MainCard>
            <Box p="xl" maw={475} miw={400}>
              <Title order={3} ta="center">
                Welcome Back
              </Title>
              <Box style={{ width: '100%', textAlign: 'center' }}>
                <Loader style={{ margin: 'auto', marginTop: '50px' }} />
                <h3>Logging In...</h3>
              </Box>
            </Box>
          </MainCard>
        </Center>
        <Box m="md" mt="xs">
          <AuthFooter />
        </Box>
      </Stack>
    </Box>
  );
};
